import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue"

import { computed } from 'vue';

import FieldHistoryBtn from 'SharedComponents/Fields/FieldHistoryBtn.vue';
import {
  BaseFieldEmits,
  ValuedFieldProps,
  defaultValuedProps,
  useBaseFieldProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useFieldParams from 'SharedComponents/Fields/composables/useFieldParams';
import { useTooltip } from 'SharedComponents/Fields/composables/useFieldTooltip';
import Tooltip from 'SharedComponents/ui/Tooltip.vue';
import useValidation, { ValidationRule } from 'SharedDir/common/composables/useValidation';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { FieldValue, TextareaFieldParams } from 'SharedDir/declarations/fields';

type TextareaFieldProps = ValuedFieldProps &
  PropValue<FieldValue<null | string>> & {
    suffix: { shortName: string };
    params: TextareaFieldParams;
    regexp?: string;
    regexpMessage?: string;
  };


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'TextareaField' },
  __name: 'TextareaField',
  props: /*@__PURE__*/_mergeDefaults({
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    modelValue: {},
    suffix: {},
    params: {},
    regexp: {},
    regexpMessage: {}
  }, {
  ...defaultValuedProps,
  suffix: () => ({ shortName: '' }),
}),
  emits: ["update:modelValue", "reveal-history"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const { MaxLength, MinLength, CheckRegex } = useValidation();

const { innerValue, emitValue } = useValue(props, emit);

const customRules = computed(() => {
  const rules: Array<ValidationRule> = [];
  if (props.params.maxLength) {
    rules.push(MaxLength(props.params.maxLength));
  }
  if (props.params.minLength) {
    rules.push(MinLength(props.params.minLength));
  }
  if (props.regexp) {
    rules.push(CheckRegex(props.regexp, props.regexpMessage));
  }
  return rules;
});

const { params, validationRules } = useFieldParams<TextareaFieldParams>(props, { customRules });

const { validationErrorStatus, hasHistory, revealHistory } = useBaseFieldProps(props, emit);

const tooltip = useTooltip(props);

const suffixCheck = computed(() => (props.suffix?.shortName ? props.suffix.shortName : ''));
const autogrow = computed(() => props.params.autogrow ?? false);
const rowsCount = computed(() => props.params.rowsCount ?? null);

return (_ctx: any,_cache: any) => {
  const _component_s_input = _resolveComponent("s-input")!

  return (_openBlock(), _createBlock(_component_s_input, {
    ref: "input",
    modelValue: _unref(innerValue).value,
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = ($event: any) => ((_unref(innerValue).value) = $event)),
      _unref(emitValue)
    ],
    label: _ctx.label,
    clearable: "",
    outlined: "",
    dense: "",
    type: "textarea",
    autogrow: autogrow.value,
    rows: rowsCount.value,
    class: _normalizeClass({ required: _ctx.required, 's-form-input_wrapper': _ctx.useWrapper }),
    "hide-bottom-space": "",
    readonly: _ctx.readonly,
    placeholder: _unref(params).placeholder ? _unref(params).placeholder : '',
    error: _unref(validationErrorStatus),
    "error-message": _ctx.errorMessage,
    disable: _ctx.disable,
    rules: _unref(validationRules)
  }, _createSlots({ _: 2 }, [
    (_unref(tooltip) || (_ctx.showHistory && _unref(hasHistory)))
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            (_unref(tooltip))
              ? (_openBlock(), _createBlock(Tooltip, {
                  key: 0,
                  text: _unref(tooltip)
                }, null, 8, ["text"]))
              : _createCommentVNode("", true),
            (_ctx.showHistory && _unref(hasHistory))
              ? (_openBlock(), _createBlock(FieldHistoryBtn, {
                  key: 1,
                  history: _ctx.history,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(revealHistory)(_ctx.label)))
                }, null, 8, ["history"]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "label", "autogrow", "rows", "class", "readonly", "placeholder", "error", "error-message", "disable", "rules", "onUpdate:modelValue"]))
}
}

})